import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { SystemConfiguration } from '../../model/system-configuration/system-configuration';

@Injectable({
  providedIn: 'root'
})
export class SystemConfigurationService {

  private api = '/SystemConfiguration';
  private configuration: SystemConfiguration;

  constructor(private dataService: DataService) {  }

  async getSystemConfiguration(): Promise<SystemConfiguration> {

    if (!this.configuration) {
      this.configuration =  await this.dataService
        .get<SystemConfiguration>(this.api).toPromise();
    }
    return this.configuration;
  }

}
